import BrandLogoHeading from "./BrandLogoHeading";

export { BrandLogoHeading as default };
